import { FormControlLabel, Switch } from "@mui/material";
import { FastField } from "formik";

const SwitchInput = ({name, label}) => {
  return (
    <FastField name={name}>
      {({field}) => {
        const {value, ...restOfFieldProps} = field;
        return (
          <FormControlLabel
            label={label} 
            control={ <Switch checked={value} {...restOfFieldProps}/> } 
          />
        );
      }}
    </FastField>
  );
}

export default SwitchInput;